import { render, staticRenderFns } from "./BaseSpace.vue?vue&type=template&id=516e4070"
import script from "./BaseSpace.vue?vue&type=script&lang=js"
export * from "./BaseSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports